import React, { useState, useEffect } from 'react';
import { Button, ButtonGroup, Form, Modal, Figure, Image, Col, Row, Card } from 'react-bootstrap';
import { Table, Dropdown, Header } from "semantic-ui-react";
import { message, Alert } from 'antd';
import Marquee from 'react-fast-marquee';
import { Auth } from 'aws-amplify';


function Home() {

	// useEffect(() => {
	// 	message.info({
	// 		content:'Due to the excellent performance of AlphaFold2 for protein structure prediction, we optimized the AlphaFold2 pipeline for structural prediction of P450 proteins, and a highly accurate protein structure can be obtained in 30 minutes once the protein sequence is submitted.',
	// 		style: {
	// 			width: '50vw',
	// 			marginLeft:"25vw",
	// 			// marginTop: '20vh',
	// 		},
	// 	});
	// }, [])

	return (
		<div style={{
			background: "#FFFFFF"

		}}>
			<div style={{

				height: "75px"
			}}>
				{/* <Alert
				banner
				type="info"
				style={{width:"100%"}}
				closable
				message={
					<Marquee pauseOnHover gradient={false} >
					Due to the excellent performance of AlphaFold2 for protein structure prediction, we optimized the AlphaFold2 pipeline for structural prediction of P450 proteins, and a highly accurate protein structure can be obtained in 30 minutes once the protein sequence is submitted.
					</Marquee>
				}
			/> */}
			</div>
			<div>
				<Row>
					<Col md={1}>
					</Col>
					<Col md={4}>
						<Image src="./home.gif" fluid />

					</Col>

					<Col md={6}>
						<Card body>

							<h2 className="top">Plant Cytochrome P450 Database</h2>
							<h2 className="homecontent">&nbsp;&nbsp;&nbsp;&nbsp;P450 databases included a P450 sequence data from 10,000 plants and 50,000 other species (P450-100), along with 1,400 functionally characterized P450 enzymes (FunP450). Additionally, we have developed tools for structure and function prediction, P450 mining, and P450 enzyme design.</h2>
							
						</Card>
						<div style={{
							height: "10px"
						}}>
						</div>
						<h5>Citing Plant Cytochrome P450 Database: </h5>
						<h5>Cytochrome P450 Enzyme Design by Constraining the Catalytic Pocket in a Diffusion Model. Research, 2024</h5>
						<h5>PCPD: Plant cytochrome P450 database and web-based tools for structural construction and ligand docking. Synthetic and Systems Biotechnology, 2021</h5>
						<h5>2020 Discovery and modification of cytochrome P450 for plant natural products biosynthesis. Synthetic and Systems Biotechnology, 2020</h5>

					</Col>
					<Col md={1}>
					</Col>
				</Row>
			</div>
			<div style={{
				height: "75px"
			}}>
			</div>
		</div>

	);
}

export default Home;